import {FETCH_WATCHON_DETAILS} from './types';
import salomapi from '../apis';

export const fetchWatchOnDetails =  () => async dispatch => {
    const response = await salomapi.get('/watchon');
    dispatch({type:FETCH_WATCHON_DETAILS,payload:response.data})
}